exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.combinedCompareTable__container {\n  flex: none;\n  min-height: 150px;\n  max-height: 200px;\n  padding-bottom: 8px;\n  overflow-y: auto;\n  margin-top: 16px;\n}\n\n.combinedCompareTable__table--show {\n  display: block;\n}\n\n.combinedCompareTable__table--hide {\n  display: none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/components/lwstats/CombinedCompareTable.scss
// module id = 434
// module chunks = 0